import { render, staticRenderFns } from "./DocumentControls.vue?vue&type=template&id=15c71bf0&scoped=true&"
import script from "./DocumentControls.vue?vue&type=script&lang=ts&"
export * from "./DocumentControls.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentControls.vue?vue&type=style&index=0&id=15c71bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c71bf0",
  null
  
)

export default component.exports